var ingredients = [
 {
   "id": "tretinoin",
   "name": "Tretinoin",
   "description": "This medication is used to treat acne. It may decrease the number and severity of acne pimples and promote quick healing of pimples that do develop. Tretinoin belongs to a class of medications called retinoids. It works by affecting the growth of skin cells."
 },
 {
   "id": "azelaic-acid",
   "name": "Azelaic Acid",
   "description": "Azelaic acid gel and foam is used to clear the bumps, lesions, and swelling caused by rosacea (a skin disease that causes redness, flushing, and pimples on the face). Azelaic acid cream is used to treat the pimples and swelling caused by acne. Azelaic acid is in a class of medications called dicarboxylic acids. It works to treat rosacea by decreasing the swelling and redness of the skin. It works to treat acne by killing the bacteria that infect pores and by decreasing production of keratin, a natural substance that can lead to the development of acne."
 },
 {
   "id": "niacinamide",
   "name": "Niacinamide",
   "description": "Niacinamide, also called nicotinamide, is a form of vitamin B3. It's found in many foods including meat, fish, milk, eggs, green vegetables, and cereals.\n\nNiacinamide is required for the function of fats and sugars in the body and to maintain healthy cells. Niacin is converted to niacinamide when it is taken in amounts greater than what is needed by the body. Unlike niacin, niacinamide doesn't help treat high cholesterol."
 },
 {
   "id": "clindamycin",
   "name": "Clindamycin",
   "description": "Clindamycin is a medication used for the treatment of numerous infections, including but not limited to septicemia, intra-abdominal infections, lower respiratory infections, gynecological infections, bone and joint infections, and skin and skin structure infections. Clindamycin is also used in the treatment of streptococcal pharyngitis, acne vulgaris, bacterial vaginosis, and severe pelvic inflammatory disease. This activity reviews the indications, action, and contraindications for clindamycin as a valuable agent in managing various infections.\n"
 },
 {
   "id": "metronidazole",
   "name": "Metronidazole",
   "description": "Metronidazole is an antibiotic that is used to treat a wide variety of infections. It works by stopping the growth of certain bacteria and parasites.This antibiotic treats only certain bacterial and parasitic infections. It will not work for viral infections (such as common cold, flu). Using any antibiotic when it is not needed can cause it to not work for future infections.Metronidazole may also be used with other medications to treat certain stomach/intestinal ulcers caused by a bacteria (H. pylori)."
 },
 {
   "id": "zinc-pyrithione",
   "name": "Zinc Pyrithione",
   "description": "Zinc pyrithione shampoo is found in many common anti-dandruff shampoos. It is antifungal, antibacterial, and antimicrobialTrusted Source, meaning it can kill fungus, bacteria, and microorganisms that can contribute to an itchy, flaky scalp."
 },
 {
   "id": "tranexamic-acid",
   "name": "Tranexamic Acid",
   "description": "Tranexamic acid is an antifibrinolytic agent. It works by blocking the breakdown of blood clots, which prevents bleeding. This medicine is available only with your doctor's prescription. "
 }
];
var selectedIngredient = ingredients[0];
setTimeout(() => {
  var oldIngredientTitle = document.getElementById(selectedIngredient.id);
  if (null != oldIngredientTitle) {
    oldIngredientTitle.classList.add("selectedIng");
  }
}, 500);

function selectIngredient(index) {
  var oldIngredientTitle = document.getElementById(selectedIngredient.id);
  if (null != oldIngredientTitle) {
    oldIngredientTitle.classList.remove("selectedIng");
  }
  selectedIngredient = ingredients[index];
   var ingredientName = document.getElementById("ingredientName");
   var ingredientBody = document.getElementById("ingredientBody");
  if (null != ingredientName) {
    ingredientName.innerHTML = selectedIngredient.name;
  }
  if (null != ingredientBody) {
    ingredientBody.innerHTML = selectedIngredient.description;
  }
  var ingredientTitle = document.getElementById(selectedIngredient.id);
  if (null != ingredientBody) {
    ingredientTitle.classList.add("selectedIng");
  }

}